import './main.less';
import 'fixed-data-table-2/dist/fixed-data-table.min.css';
import React from 'react';
import PropTypes from 'prop-types';
import { Table, Column } from 'fixed-data-table-2';

import HeaderCell from './cells/header';
import DataCell from './cells/data';
import AffOfferCell from './cells/aff-offer';

import get from 'lodash/get';
import find from 'lodash/find';

const propTypes = {
	intl: PropTypes.func,
	table: PropTypes.shape({
		header: PropTypes.array,
		rows: PropTypes.array,
		activeCell: PropTypes.array
	}),
	cellConfig: PropTypes.array,
	datePeriodFilters: PropTypes.array,
	currentDateRange: PropTypes.object,
	toggleTableProgressBar: PropTypes.func,
	changeGroupOrderDuration: PropTypes.func,
	groupOrder: PropTypes.func,
	groupSelect: PropTypes.array,
	data: PropTypes.object
};

class FixedTable extends React.Component {
	constructor(props) {
		super(props);

		this.dateGroupPeriod = get(find(this.props.datePeriodFilters, {active: true}), 'value');
		this.dateRange = this.props.currentDateRange;
		this.headerHeight = 40;
		this.rowHeight = 40;
		this.minColumnWidth = 75;

		this.state = {
			tableWidth: 0,
			tableHeight: 500,
			rowsVisibilityConfig: {
				method: 'hide',
				rowRefsName: []
			}
		};
	}

	componentDidMount() {
		this.setTableViewportRect();
	}

	render() {
		const table = this.filterRowsVisibility(this.props.table);
		const columnWidth = table.activeCell.length * this.minColumnWidth;
		const [ firstGroup, secondGroup ] = this.props.groupSelect.values;
		const groupTitleName = `${firstGroup.label} and ${secondGroup.label}`;

		return (
			<div className="activity-table-wrapper" ref={node => this.$wrapper = node}>
				<div className="activity-table-wrapper__axes-x" ref={node => this.axesX = node}></div>
				<div className="activity-table-wrapper__axes-y" ref={node => this.axesY = node}></div>
				{ this.state.tableWidth && (
					<Table
						headerHeight={this.headerHeight}
						rowHeight={this.rowHeight}
						width={this.state.tableWidth}
						height={this.state.tableHeight}
						rowsCount={table.rows.length}
						onHorizontalScroll={this.hideAxes.bind(this)}
						onVerticalScroll={this.hideAxes.bind(this)}
						{...this.props}>
						<Column
							columnKey="affiliate_offer"
							header={
								<HeaderCell
									classNameModify="sticky"
									groupDayPeriod={this.dateGroupPeriod}
									dateRange={this.dateRange}
									rowsVisibilityConfig={this.state.rowsVisibilityConfig}
									activeCell={table.activeCell}
									title={groupTitleName}
									currentOrderDuration={table.orderDuration}
									onToggleExpandAllRows={this.onToggleExpandAllRows.bind(this)}
									onOrder={this.props.groupOrder}/>
							}
							cell={
								<AffOfferCell
									classNameModify="sticky"
									onToggleExpandRow={this.onToggleExpandRow.bind(this)}
									rowsVisibilityConfig={this.state.rowsVisibilityConfig}
									conversionData={this.props.data.data}
									data={table.rows} />
							}
							fixed={true}
							width={340}
						/>

						{ table.header.map(date => (
							<Column
								key={date}
								columnKey={`date-${date}`}
								header={
									<HeaderCell
										dateRange={this.dateRange}
										groupDayPeriod={this.dateGroupPeriod}
										activeCell={table.activeCell}
										title={date} />
								}
								cell={
									<DataCell
										filterKey={date}
										axesCalculateData={{
											axesXRef: this.axesX,
											axesYRef: this.axesY,
											wrapperRect: this.$wrapper.getBoundingClientRect()
										}}
										cellConfig={this.props.cellConfig}
										data={table.rows} />
								}
								width={columnWidth}
							/>
						)) }
					</Table>
				) }
			</div>
		);
	}

	setTableViewportRect() {
		const table = this.filterRowsVisibility(this.props.table);

		const { rows } = table;
		const totalRowsHeight = (rows.length * this.rowHeight) + this.rowHeight + 20;
		const { top, width } = this.$wrapper.getBoundingClientRect();
		const viewportHeight = window.innerHeight - top - this.rowHeight;

		const tableHeight = totalRowsHeight > viewportHeight ? viewportHeight : totalRowsHeight;

		this.setState({
			tableWidth: width,
			tableHeight
		});
	}

	hideAxes() {
		this.axesX.style.display = 'none';
		this.axesY.style.display = 'none';
		return true;
	}

	filterRowsVisibility(table) {
		const { rowsVisibilityConfig: { rowRefsName, method } } = this.state;

		// @todo show strategy by method

		return {
			...table,
			rows: table.rows.filter(row => {
				const isTotal = row.column.is_total;
				return isTotal || (
					method === 'hide' &&
					rowRefsName.indexOf(row.column.affiliateRefs) !== -1
				) || (
					method === 'show' &&
					rowRefsName.indexOf(row.column.affiliateRefs) === -1
				);
			})
		};
	}

	onToggleExpandRow(affiliateRefs) {
		const { rowsVisibilityConfig: { rowRefsName } } = this.state;
		const index = rowRefsName.indexOf(affiliateRefs);

		this.setState(
			prevState => ({
				rowsVisibilityConfig: {
					...this.state.rowsVisibilityConfig,
					rowRefsName: index === -1
						? [].concat(rowRefsName, affiliateRefs)
						: rowRefsName.filter(row => row !== affiliateRefs)
				}
			}),
			() => this.setTableViewportRect()
		);
	}

	onToggleExpandAllRows() {
		this.setState(
			prevState => ({
				rowsVisibilityConfig: {
					...this.state.rowsVisibilityConfig,
					rowRefsName: [],
					method: this.state.rowsVisibilityConfig.method === 'hide' ? 'show' : 'hide'
				}
			}),
			() => this.setTableViewportRect()
		);
	}
}

FixedTable.propTypes = propTypes;
export default FixedTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/table/main.js